import {
  IBinLocation,
  ILocation,
} from '../../location/interfaces/location.interface';
import { ILot } from '../../lot/interfaces/lot.interface';
import { IRfqLot } from '../../rfq/interfaces/rfq-lot.interface';
import { IRfq } from '../../rfq/interfaces/rfq.interface';
import { IUnitOfMeasure } from '../../unit-of-measure/interfaces/unit-of-measure.interface';

export interface OrderSalesInterface {
  id :number;
  orderId :number;
  orderNumber :string;
  totalOrderQuantity :number;
  orderTotal :number;
  orderDate :Date;
  createDate :Date;
  orderStatus :string;
  paymentMethod :string;
  amountPaid :number;
  source :string;
  skipInventory :boolean;
  orderItems :OrderSalesItemInterface[];
  items :OrderSalesItemInterface[];
}

export interface OrderSalesItemInterface {
  id :number;
  productId :number | null;
  rfqId :number | null;
  rfq :IRfq | null;
  kitId :number | null;
  sku :string;
  name :string;
  productDescription :string;
  unitPrice :number;
  quantity :number;
  totalReturnedBaseQuantity :number;
  orderedQuantity :number;
  quantityCancelled :number;
  quantityShipped :number;
  locationId :number | null;
  location :ILocation | null;
  lotId :number | null;
  lot :ILot | null;
  baseUomId :number;
  baseUom :IUnitOfMeasure | null;
  orderedUomId :number;
  orderedUom :IUnitOfMeasure | null;
}
export interface IPickingItemsResponse {
  pickingItems :IPickingItem[];
  salesOrder :any;
}
export interface IPickingItem {
  rfqId :number;
  sku :string;
  productName :string;
  orderedQuantity :number;
  availableQuantity :number;
  onhandStockQuantity :number;
  rfq ?:IPickingItemRfq;
  location ?:IBinLocation;
  warehouse ?:IBinLocation;
  lot ?:IRfqLot;
  fulfilled ?:boolean;
  incomingOrders ?:IPickingItemIncomingOrder[];
}
export interface IPickingItemRfq {
  base_unit_of_measure ?:number;
  id :number;
  total_variant_skus :number;
  internal_sku :string;
  product_name :string;
}

export interface IPickingItemIncomingOrder {
  id :number;
  internal_sku :string;
  ordered_qty :number;
  purchase_order_id :number;
  purchase_order :IIncomingPurchaseOrder;
}

export interface IIncomingPurchaseOrder {
  id :number;
  arrival_due_date :string;
  order_date :string;
}

export enum ESalesOrderPostStatus {
  POSTED = 1,
  NOT_POSTED = 0,
}
